import React from 'react';
import { StyleSheet, View } from 'react-native';
import { TextLink, theme } from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

export const RequestAccountDeletionTrigger = (
  props: RequestAccountDeletionTriggerProps,
) => {
  const { onRequestAccountDeletion } = props;
  const { t } = useLocalizationContext();

  return (
    <View style={styles.triggerContainer}>
      <TextLink
        testID="account.delete.trigger"
        style={styles.trigger}
        onPress={onRequestAccountDeletion}
      >
        {t('account.delete.trigger')}
      </TextLink>
    </View>
  );
};

type RequestAccountDeletionTriggerProps = Readonly<{
  onRequestAccountDeletion: () => void;
}>;

const styles = StyleSheet.create({
  triggerContainer: {
    alignItems: 'center',
    marginTop: theme.spacing['10'],
  },
  trigger: {
    color: theme.colors.CAUTION,
  },
});
